(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alltrueist-atelier-cover"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const frames = Array.from(root.querySelectorAll('[data-atelier-frame]'));
    const control = root.querySelector('[data-atelier-pause]');
    if (frames.length < 2 || !control) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let playing = root.dataset.autoplay === 'true' && !reduce.matches;
    let timer;
    let visible = true;
    const show = () => frames.forEach((frame, i) => {
      frame.classList.toggle('is-current', i === current);
      frame.setAttribute('aria-hidden', String(i !== current));
    });
    const sync = () => {
      window.clearInterval(timer);
      root.classList.toggle('is-paused', !playing || !visible || document.hidden);
      control.textContent = playing ? control.dataset.pause : control.dataset.play;
      if (playing && visible && !document.hidden) timer = window.setInterval(() => { current = (current + 1) % frames.length; show(); }, 11000);
    };
    const toggle = () => { playing = !playing; sync(); };
    const preference = () => { if (reduce.matches) playing = false; sync(); };
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: .1 });
    observer.observe(root.querySelector('[data-atelier-frames]'));
    control.hidden = false;
    control.addEventListener('click', toggle);
    reduce.addEventListener('change', preference);
    document.addEventListener('visibilitychange', sync);
    root.addEventListener('atelier:unload', () => { window.clearInterval(timer); observer.disconnect(); reduce.removeEventListener('change', preference); document.removeEventListener('visibilitychange', sync); control.removeEventListener('click', toggle); }, { once: true });
    show();
    sync();
  }
  document.querySelectorAll('[data-ma-atelier]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ma-atelier]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ma-atelier]').forEach(root => root.dispatchEvent(new Event('atelier:unload'))));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alltrueist-atelier-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const frames = Array.from(root.querySelectorAll('[data-atelier-frame]'));
    const control = root.querySelector('[data-atelier-pause]');
    if (frames.length < 2 || !control) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let playing = root.dataset.autoplay === 'true' && !reduce.matches;
    let timer;
    let visible = true;
    const show = () => frames.forEach((frame, i) => {
      frame.classList.toggle('is-current', i === current);
      frame.setAttribute('aria-hidden', String(i !== current));
    });
    const sync = () => {
      window.clearInterval(timer);
      root.classList.toggle('is-paused', !playing || !visible || document.hidden);
      control.textContent = playing ? control.dataset.pause : control.dataset.play;
      if (playing && visible && !document.hidden) timer = window.setInterval(() => { current = (current + 1) % frames.length; show(); }, 11000);
    };
    const toggle = () => { playing = !playing; sync(); };
    const preference = () => { if (reduce.matches) playing = false; sync(); };
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: .1 });
    observer.observe(root.querySelector('[data-atelier-frames]'));
    control.hidden = false;
    control.addEventListener('click', toggle);
    reduce.addEventListener('change', preference);
    document.addEventListener('visibilitychange', sync);
    root.addEventListener('atelier:unload', () => { window.clearInterval(timer); observer.disconnect(); reduce.removeEventListener('change', preference); document.removeEventListener('visibilitychange', sync); control.removeEventListener('click', toggle); }, { once: true });
    show();
    sync();
  }
  document.querySelectorAll('[data-ma-atelier]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ma-atelier]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ma-atelier]').forEach(root => root.dispatchEvent(new Event('atelier:unload'))));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alltrueist-repair"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var button = event.target.closest('.ar-guide__toggle');
  if (button) {
    var isOpen = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    button.closest('.ar-guide').classList.toggle('is-open', isOpen);
  }
});
document.addEventListener('input', function(event) {
  if (event.target.matches('.ar-comparison__range')) {
    event.target.closest('.ar-comparison').style.setProperty('--reveal', event.target.value + '%');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
